module.exports = __webpack_public_path__ + "img/type-strikethrough.ca377e82.svg";